import React, { useEffect, useMemo } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import GlobalValuesAddEdit from "./GlobalValuesAddEdit";
import GlobalValuesTable from "./GlobalValuesTable";

function GlobalValuesTableContainer(props) {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route path={`${path}/edit/:id`}>
          <GlobalValuesAddEdit />
        </Route>
        <Route path={`${path}/add`}>
          <GlobalValuesAddEdit />
        </Route>
        <Route path={`${path}`}>
          <GlobalValuesTable />
        </Route>
      </Switch>
    </>
  );
}

export default GlobalValuesTableContainer;
